<template>
    <div class="list-main">
        <div class="list-header">
            <div class="header-box fl">
                <div class="title">电子期刊</div>
            </div>
            <a-input class="input fr" placeholder="请输入关键字" v-model="keyword">
                <a-icon slot="suffix" type="search" @click="searchHandler()"/>
            </a-input>
        </div>

        <div class='list-body'>
            <div class='item' v-for="item ,index in list" :key="index" @click="$router.push({path:'/newHome/paper/detail',query:{paperId:item.id}})">
                <div class="drop fl"></div>
                <div class="title fl">{{ item.title }}</div>
                <div class="time fr">{{ item.pubtime.substring(0,10) }}</div>
            </div>
        </div>

        <div class="pagination">
            <a-pagination :total="total" show-quick-jumper :show-total="total => `共有 ${total} 条信息`" :item-render="itemRender" @change="changeHandler"/>
        </div>
        <div style="height: 20px;"></div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            type : null,
            keyword: '',
            total:0,
            list:[],
            current:1,
        };
    },

    mounted() {
        this.getMagazine()
    },

    methods: {
        changeHandler(current ,size){
            this.current = current
            this.getMagazine()
        },
        searchHandler(){
            this.current = 1
            this.getMagazine()
        },
        getMagazine(){
            const params = {
                currentPage:this.current,
                title:this.keyword
            }
            this.$http.getMoreList(params).then(res=>{
                if(res.success){
                    this.list = res.paperMoreList;
                    this.total = res.page.allSize
                }
            })
        },
        itemRender(current, type, originalElement){
            if (type==='prev'){
                return <a>上一页</a>
            }else if(type==='next'){
                return <a>下一页</a>
            }
            return originalElement;
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/scss/home/news.scss";
</style>